import { render } from "./AppModel.vue?vue&type=template&id=5038cfea&scoped=true"
import script from "./AppModel.vue?vue&type=script&lang=js"
export * from "./AppModel.vue?vue&type=script&lang=js"

import "./AppModel.vue?vue&type=style&index=0&id=5038cfea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5038cfea"]])

export default __exports__